import { render, staticRenderFns } from "./self_validate.vue?vue&type=template&id=0b931514&scoped=true"
import script from "./self_validate.vue?vue&type=script&lang=js"
export * from "./self_validate.vue?vue&type=script&lang=js"
import style0 from "./self_validate.vue?vue&type=style&index=0&id=0b931514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b931514",
  null
  
)

export default component.exports